import { useQueryParams } from 'use-query-params'
import { stringQueryParamEncoder } from 'utils/query-params/string.utils'

const queryParamsEncoders = {
  preselectRole: stringQueryParamEncoder,
}

export const useCreateAccountQueryParams = () => {
  const [params] = useQueryParams(queryParamsEncoders)

  return {
    preselectRole: params.preselectRole,
  }
}
